import AdvancedPage from './AdvancedPage';
export default AdvancedPage;
